import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { FileUploader } from '@/new/components/file-uploader';

export function MatterCreatorFiles() {
  const { matterId } = useParams();
  const [filesProcessing, setFilesProcessing] = useState(false);

  if (!matterId) return null;

  return <FileUploader setFilesProcessing={setFilesProcessing} isMatterCreator={true} />;
}
